import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "CardDiamond.svg",
  "use": "CardDiamond.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"CardDiamond.svg\"><path d=\"M45,56H19a4,4,0,0,1-4-4V12a4,4,0,0,1,4-4H45a4,4,0,0,1,4,4V52A4,4,0,0,1,45,56ZM41.6026,31.1749c-2.6056-1.9561-7.2759-6.9736-8.9344-11.6639a.6932.6932,0,0,0-1.3363,0c-1.6585,4.69-6.3289,9.7078-8.9343,11.6639a1.0594,1.0594,0,0,0,0,1.6545c2.6054,1.9561,7.2758,6.9738,8.9343,11.6639a.6932.6932,0,0,0,1.3363,0c1.6585-4.69,6.3288-9.7078,8.9344-11.6639a1.06,1.06,0,0,0,0-1.6545Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol